import _ from "lodash";

import Box from "components/Box";
import Container from "components/Container";
import PageHeader from "components/PageHeader";
import Skeleton from "components/Skeleton";
import Stack from "components/Stack";
import { usePageTitle } from "components/usePageTitle";

import { useSignedUser } from "entities/Auth/sdk";
import SubscriptionDetails from "entities/Company/components/CompanySettings/SubscriptionDetails";
import ExternalAPIsInfoBox from "entities/Company/components/ExternalAPIsInfoBox";
import CompanyProfileInfoBox from "entities/Company/components/ProfileInfoBox";
import CompanyTeamInfoBox from "entities/Company/components/TeamInfoBox";
import { useCurrentCompany } from "entities/Company/sdk";
import UserInfoBox from "entities/User/components/InfoBox";
import StickySidebar from "entities/User/components/StickySidebar";

const Profile = () => {
  usePageTitle("Builders Patch: Profile");
  const { data: user } = useSignedUser();

  const { data: company } = useCurrentCompany();

  return (
    <Container>
      <Stack spacing={2}>
        <PageHeader title="My account" />
        <Stack
          spacing={4}
          direction="row"
          sx={{
            maxWidth: "100%",
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ width: "280px" }}>
            <StickySidebar />
          </Box>
          <Stack
            data-testid="profile-sections"
            gap={4}
            style={{ flex: 1, maxWidth: "100%", overflowX: "hidden" }}
          >
            {_.isNil(user) || _.isNil(company) ? (
              _.range(5).map((i) => (
                <Skeleton key={i} height={300} sx={{ transform: "unset" }} />
              ))
            ) : (
              <>
                <UserInfoBox user={user} />
                <CompanyProfileInfoBox company={company} user={user} />
                {company.external_apis_enabled && (
                  <ExternalAPIsInfoBox company={company} />
                )}
                <CompanyTeamInfoBox employees={company.employees} user={user} />
              </>
            )}

            <SubscriptionDetails />
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};
export default Profile;
